export default __webpack_public_path__ + "static/media/virtual_care.png.webp";